import { render, staticRenderFns } from "./WineCard.vue?vue&type=template&id=3b895c20&"
import script from "./WineCard.vue?vue&type=script&lang=js&"
export * from "./WineCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports